module.exports = __webpack_public_path__ + "static/1-d6625f0cff518cbc4334d8ff79c87600.png";